import { z } from 'zod';

const serviceFacilityTypeSchema = z.looseObject({
  emboldId: z.number(), // @TODO the ETL may need to change this to be a string since the id's can exceed the JS integer limit
  name: z.string(),
});
export const serviceSchema = z.looseObject({
  id: z.number(),
  serviceId: z.number(),
  serviceName: z.string(),
  specialtyId: z.number().optional(),
  specialtyName: z.string().optional(),
  subspecialtyId: z.number().optional(),
  subspecialtyName: z.string().optional(),
  facilityTypes: z.array(serviceFacilityTypeSchema),
  serviceType: z.union([z.literal('provider'), z.literal('place')]),
});

export type Service = z.infer<typeof serviceSchema>;
